import { Client } from "../client/interfaces";
import { Project } from "../project/interfaces";

const CODE_IDX = 1;

const searchData: Record<string, string[]> = {};
let searchDataLength = 0;

const setup = (items: Project[]) => {
    for (const item of items) {
        const parts = [
            item.client.toLowerCase(),
            item.project.toString().padStart(4, "0"),
            ...item.name
                .replace(/[^a-zA-Z0-9 ]/g, " ")
                .toLowerCase()
                .split(" ")
                .filter((i) => i),
        ];

        searchData[item.id] = parts;
    }

    searchDataLength = items.length;
};

const matchClient = (q: string, item: Project, clients: Client[]) =>
    clients
        .find((c) => c.client === item.client)
        ?.name_internal.toLowerCase()
        .startsWith(q);

const matchParts = (qp: string[], vp: string[]) => {
    if (qp.length > vp.length) {
        return false;
    }

    let c = 0;

    for (let i = 0; i < qp.length; i++) {
        for (; c < vp.length; c++) {
            if (c !== CODE_IDX) {
                if (vp[c].startsWith(qp[i])) {
                    break;
                }
            } else if (vp[c].includes(qp[i])) {
                break;
            }
        }

        if (c === vp.length) {
            return false;
        }
    }

    return true;
};

const match = (
    q: string,
    q0: string,
    q1: string,
    item: Project,
    clients: Client[],
) =>
    item.name.toLowerCase().includes(q) ||
    item.project.toString().startsWith(q0) ||
    item.client.toLowerCase().startsWith(q) ||
    `${item.client}${item.project}`.toLowerCase().startsWith(q1) ||
    matchClient(q, item, clients);

export const filterProjects = <T extends Project>(
    items: T[],
    query: string,
    clients: Client[] = [],
    selectedClient = "",
) => {
    if (selectedClient) {
        items = items.filter((i) => i.client === selectedClient);
    }

    const q = query.toLowerCase().trim();

    if (!q) {
        return items;
    }

    if (items.length > searchDataLength) {
        setup(items);
    }

    const q0 = q.replace(/^0+/, "");
    const q1 = q.replace(/\b0+|\s+/g, "");
    const qp = q
        .replace(/[^a-zA-Z0-9 ]/g, " ")
        .split(" ")
        .filter((i) => i);

    return items.filter((item) =>
        item.id in searchData
            ? matchParts(qp, searchData[item.id]) ||
              matchClient(q, item, clients)
            : match(q, q0, q1, item, clients),
    );
};
